import {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {environment} from '~local/environments/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    if (req.url.startsWith('local:')) {
        req = req.clone({ url: req.url.substring(6, req.url.length) });
    } else if (!/^(http|https):/i.test(req.url)) {
        req = req.clone({ url: environment.serverUrl + req.url });
    }
    return next(req);
}

